import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useAuthStore } from '@wordpuppi/shared';
import { useEffect, useRef } from 'react';

export const Route = createFileRoute('/')({
  component: IndexPage,
});

function IndexPage() {
  const { isAuthenticated } = useAuthStore();
  const navigate = useNavigate();
  const hasRedirected = useRef(false);

  useEffect(() => {
    if (hasRedirected.current) return;
    hasRedirected.current = true;

    if (!isAuthenticated) {
      navigate({ to: '/login' });
    } else {
      navigate({ to: '/sites', replace: true });
    }
  }, [isAuthenticated, navigate]);

  return null;
}
